<script setup lang="ts">
import { computed, provide } from 'vue'
import { RouterView } from 'vue-router'
import NotificationBanner from '@/components/NotificationBanner.vue'
import { useBanner } from '@/composables/useBanner'

const banner = useBanner()
provide('announcementBanner', banner)

const contentStyle = computed(() => ({
  paddingTop: banner.totalTopOffsetPx.value
}))
</script>

<template>
  <div id="app-root">
    <NotificationBanner />
    <div class="app-content" :style="contentStyle">
      <RouterView />
    </div>
  </div>
</template>

<style scoped>
.app-content {
  min-height: 100vh;
  box-sizing: border-box;
}
</style>
